import type { ReadonlyNonEmptyArray } from '../../../utils'

import { FileExtensionType } from '../..'
import { ReloadLicenseUsecase } from './Reload'

export class UploadLicenseFileUsecase extends ReloadLicenseUsecase {
    async upload (fileContent: string): Promise<void> {
        await this.changeLicense(() => this.systemService.uploadLicenseFile(fileContent))
    }

    getSupportedLicenseFileExtensions (): ReadonlyNonEmptyArray<string> {
        return this.configurationService.getSupportedFileExtensions(FileExtensionType.LICENSE)
    }
}
